import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useInvalidateQueries } from '../../../../hooks/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import { ApiService } from '../../../../services/index';
import { Perk } from '../perks.types';

export const usePerk = (id: string) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS, QueryKey.GET, id);
  const { data: record, isLoading } = useAppQuery({
    queryKey: [QueryKey.PERKS, QueryKey.GET, id],
    queryFn: () =>
      ApiService.get<Perk>(
        {
          endpoint: BackendRoute.PERKS,
          routePath: [id],
        },
        { regularBackend: true },
      ),
    enabled: Boolean(id),
  });

  return {
    invalidateQuery,
    record,
    isLoading,
  };
};
